module.exports = __webpack_public_path__ + "static/media/student.ab5a45d4.png";